import { useQuery } from '@tanstack/react-query';
import { api } from '../lib_api';

export default function AiEvents() {
  const events = useQuery({ queryKey: ['admin', 'ai', 'events'], queryFn: async () => (await api.get('/api/ai/admin/events')).data });
  return (
    <section className="space-y-4">
      <div className="rounded-lg border border-gray-200 bg-white p-4 dark:border-darkCard dark:bg-darkCard/60">
        <h3 className="text-sm font-semibold">Recent AI Events</h3>
      </div>
      <div className="overflow-x-auto rounded-lg border border-gray-200 bg-white dark:border-darkCard dark:bg-darkCard/60">
        <table className="min-w-full text-sm">
          <thead><tr><th>Time</th><th>Feature</th><th>Status</th><th>Reason</th><th>Cost</th></tr></thead>
          <tbody>
            {(events.data?.items || []).map((row: any) => (
              <tr key={row.id}><td>{new Date(row.created_at).toLocaleString()}</td><td>{row.feature_key}</td><td>{row.status}</td><td>{row.reason_code || '—'}</td><td>{row.actual_cost_usd ?? row.estimated_cost_usd}</td></tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
